import { render, staticRenderFns } from "./modalCrearProyecto.vue?vue&type=template&id=88c6caa2"
import script from "./modalCrearProyecto.vue?vue&type=script&lang=js"
export * from "./modalCrearProyecto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports